// ── SCROLL SCRUB ENGINE ───────────────────────────────
(function(){
  const canvas = document.getElementById('scrub-canvas');
  if(!canvas) return;

  const ctx   = canvas.getContext('2d');
  const zone  = document.getElementById('scrub-zone');
  const stage = document.getElementById('scrub-stage');
  const navEls = document.querySelectorAll('.announcement-bar-section, .section-header');
  const scrollCue   = document.getElementById('scrollCue');
  const act1  = document.getElementById('act1');
  const act2  = document.getElementById('act2');
  const act3  = document.getElementById('act3');
  const heroStat    = document.getElementById('heroStat');
  const annotations = document.getElementById('annotations');
  const annShellLabel = document.getElementById('annShellLabel');
  const annNutLabel   = document.getElementById('annNutLabel');
  const dotShell = document.getElementById('dotShell');
  const dotNut   = document.getElementById('dotNut');
  const lineShell= document.getElementById('lineShell');
  const lineNut  = document.getElementById('lineNut');

  const IMG_W = 1280, IMG_H = 720;

  const CORE_KEYS = [
    [188,0.618,0.480],[192,0.615,0.476],[200,0.612,0.462],[206,0.588,0.458],
    [211,0.559,0.456],[215,0.573,0.453],[219,0.582,0.450],[223,0.584,0.457],
    [227,0.586,0.464],[231,0.589,0.474],[235,0.595,0.476],[239,0.595,0.476]
  ];
  const SHELL_OFFSET = { x:-0.035, y:-0.206 };
  const NUT_ANCHOR   = { x:0.68,   y:0.46  };
  const LABELS = {
    shell:    { el:annShellLabel, at:{x:0.44, y:0.28}, align:'right' },
    nutrient: { el:annNutLabel,   at:{x:0.985,y:0.47}, align:'right' }
  };

  function coreAt(fr){
    const K=CORE_KEYS, last=K.length-1;
    if(fr<=K[0][0]) return {x:K[0][1], y:K[0][2]};
    if(fr>=K[last][0]) return {x:K[last][1], y:K[last][2]};
    for(let i=0;i<last;i++){
      if(fr<=K[i+1][0]){
        const t=(fr-K[i][0])/(K[i+1][0]-K[i][0]);
        return {x:K[i][1]+(K[i+1][1]-K[i][1])*t, y:K[i][2]+(K[i+1][2]-K[i][2])*t};
      }
    }
    return {x:K[last][1], y:K[last][2]};
  }

  function pad(n){ return String(n).padStart(6,'0'); }

  // Prefer the visual viewport when available: it tracks the ACTUAL current
  // rendered viewport (including mobile browser chrome showing/hiding),
  // whereas window.innerWidth/innerHeight can hold a value from a transient
  // layout pass that never gets corrected until a real 'resize' event fires —
  // which is what used to leave a permanent gap on the right/bottom edge of
  // the canvas on mobile until the address bar happened to change state.
  function viewportSize(){
    if(window.visualViewport){
      return { w: window.visualViewport.width, h: window.visualViewport.height };
    }
    return { w: window.innerWidth, h: window.innerHeight };
  }

  let TOTAL = 240;
  const imgs = [];
  let currentFrame = 0, rafPending = false;

  function resize(){
    const vp = viewportSize();
    canvas.width  = vp.w;
    canvas.height = vp.h;
    draw(currentFrame);
    positionAnnotations();
  }

  function draw(n){
    const im = imgs[n];
    if(!im||!im.complete||!im.naturalWidth) return;
    const cw=canvas.width, ch=canvas.height;
    const iw=im.naturalWidth, ih=im.naturalHeight;
    const sc=Math.max(cw/iw, ch/ih);
    ctx.clearRect(0,0,cw,ch);
    ctx.drawImage(im, (cw-iw*sc)/2, (ch-ih*sc)/2, iw*sc, ih*sc);
    positionAnnotations();
  }

  function imgRect(){
    const cw=canvas.width, ch=canvas.height;
    const sc=Math.max(cw/IMG_W, ch/IMG_H);
    const dW=IMG_W*sc, dH=IMG_H*sc;
    return { dx:(cw-dW)/2, dy:(ch-dH)/2, dW, dH, cw, ch };
  }

  function positionAnnotations(){
    if(!dotShell) return;
    const r=imgRect();
    const toScreen=f=>({ x:r.dx+f.x*r.dW, y:r.dy+f.y*r.dH });
    const core=coreAt(currentFrame);
    const dn=toScreen(NUT_ANCHOR);
    const ds=toScreen({ x:core.x+SHELL_OFFSET.x, y:core.y+SHELL_OFFSET.y });
    dotShell.style.left=ds.x+'px'; dotShell.style.top=ds.y+'px';
    dotNut.style.left=dn.x+'px';   dotNut.style.top=dn.y+'px';

    function placeLabel(a){
      const p=toScreen(a.at), w=a.el.offsetWidth, h=a.el.offsetHeight, m=16;
      // Keep labels below the fixed header so the pills don't overlap it.
      const headerEl = document.querySelector('.section-header');
      let topSafe = m;
      if(headerEl){ topSafe = Math.max(m, headerEl.getBoundingClientRect().bottom + 12); }
      let left=(a.align==='right') ? p.x-w : p.x;
      let top=p.y-h/2;
      left=Math.max(m, Math.min(r.cw-w-m, left));
      top =Math.max(topSafe, Math.min(r.ch-h-m, top));
      a.el.style.left=left+'px'; a.el.style.top=top+'px'; a.el.style.right='auto';
      return {left,top,w,h};
    }
    const ls=placeLabel(LABELS.shell), ln=placeLabel(LABELS.nutrient);

    function setLine(el, lab, dot){
      const ex=(dot.x > lab.left+lab.w/2) ? lab.left+lab.w : lab.left;
      const ey=lab.top+lab.h/2;
      el.setAttribute('x1',(ex/r.cw*100).toFixed(2));
      el.setAttribute('y1',(ey/r.ch*100).toFixed(2));
      el.setAttribute('x2',(dot.x/r.cw*100).toFixed(2));
      el.setAttribute('y2',(dot.y/r.ch*100).toFixed(2));
    }
    if(lineShell) setLine(lineShell, ls, ds);
    if(lineNut)   setLine(lineNut,   ln, dn);
  }

  function show(el, on){ if(el) el.classList.toggle('visible', on); }

  function update(){
    rafPending = false;
    if(!zone) return;
    const zTop = zone.offsetTop;
    const zH   = zone.offsetHeight;
    const vH   = window.innerHeight;
    const scrolled = window.scrollY - zTop;
    const p = Math.max(0, Math.min(1, scrolled / (zH - vH)));
    const fr = Math.min(TOTAL-1, Math.floor(p * TOTAL));
    if(fr !== currentFrame){ currentFrame=fr; draw(fr); }

    show(act1,        p < 0.30);
    show(act2,        p >= 0.30 && p < 0.62);
    show(act3,        p >= 0.62);
    show(heroStat,    p >= 0.66);
    show(annotations, p >= 0.80);

    if(scrollCue) scrollCue.style.opacity = scrolled > 50 ? '0' : '1';

    const past = window.scrollY > (zTop + zH - vH);
    navEls.forEach(function(el){ el.classList.toggle('opaque', past); });

    const exitP = Math.max(0, Math.min(1, (window.scrollY - (zTop + zH - vH)) / (vH * 0.22)));
    const radius = Math.round(exitP * 80);
    if(stage){
      stage.style.borderBottomLeftRadius  = radius + 'px';
      stage.style.borderBottomRightRadius = radius + 'px';
    }
  }

  function onScroll(){
    if(rafPending) return;
    rafPending = true;
    requestAnimationFrame(update);
  }

  // Wait for the browser to report real viewport dimensions before doing
  // anything size- or breakpoint-dependent. Right after navigation these can
  // transiently read 0 (or a stale, too-narrow value) before layout has
  // settled — and both readings get baked in permanently if trusted here:
  // canvas.width/height come from window.innerWidth/innerHeight inside
  // resize(), and IS_MOBILE (which frame set to load) is decided once,
  // right below, before any image request goes out. A bogus 0-size resize()
  // draws every frame at zero scale (invisibly) with no way to recover
  // unless a genuine 'resize' event fires later — e.g. a mobile browser's
  // address bar collapsing on scroll, which is why scrolling used to "fix"
  // the black hero. Retrying until the reading is sane makes this correct
  // regardless of when a given browser's first real layout pass lands.
  function start(){
    const vp0 = viewportSize();
    if(!(vp0.w > 0 && vp0.h > 0)){
      requestAnimationFrame(start);
      return;
    }

    TOTAL = window.__scrubFrameCount || 240;
    // On small screens use the portrait (9:16) frame set so the bottle stays framed.
    const IS_MOBILE = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    const TEMPLATE = (IS_MOBILE && window.__scrubFrameTemplateMobile)
      ? window.__scrubFrameTemplateMobile
      : (window.__scrubFrameTemplate || '');
    // Nothing to scrub — bail instead of firing 240 requests with an empty src.
    if(!TEMPLATE) return;

    for(let i=0;i<TOTAL;i++){
      const im = new Image();
      im.src = TEMPLATE.replace(/\d{6}(?=\.jpg)/, pad(i));
      imgs.push(im);
    }
    // Keep checking every animation frame until frame 0 is actually decoded,
    // instead of trusting a single 'load' listener, which can be missed
    // outright (bfcache restores, prerender, slow mobile decode).
    (function paintWhenReady(){
      if(imgs[0].complete && imgs[0].naturalWidth){ draw(0); }
      else { requestAnimationFrame(paintWhenReady); }
    })();

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', resize);
    // The visual viewport (not window.resize) is what actually fires when a
    // mobile browser's address bar shows/hides or the page finishes settling
    // right after load — without this, a canvas sized from an early,
    // slightly-too-small reading can stay that way indefinitely, leaving a
    // permanent gap along the right/bottom edge.
    if(window.visualViewport){
      window.visualViewport.addEventListener('resize', resize);
    }
    resize();
    update();
    // Mobile browsers can still settle their chrome (address bar, safe-area)
    // a beat after the first layout pass; a couple of follow-up resizes over
    // the next second catch that without needing a real resize/scroll event.
    setTimeout(resize, 300);
    setTimeout(resize, 1000);
  }
  start();
})();

// ── PRODUCT HORIZONTAL SCROLL SCRUB ─────────────────
(function(){
  const zone  = document.getElementById('product-zone');
  const track = document.getElementById('product-track');
  const dots  = document.querySelectorAll('.pp-dot');
  const hint  = document.getElementById('pslideHint');
  if(!zone || !track) return;

  const SLIDES  = dots.length || 3;
  // Must match .pslide width / #product-track gap in theme.css, or the
  // desktop scrub drifts off-centre.
  const CARD_PX = 590;
  const GAP_PX  = 20;

  function stepPx(){ return CARD_PX + GAP_PX; }
  function zoneDocTop(){ return zone.getBoundingClientRect().top + window.scrollY; }
  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }

  // The section slides in, stops with "The range" at the top of the screen,
  // and only then does the horizontal scrub begin.
  function entryPx(){ return 0; }

  function updateProducts(){
    if(isMobile()){ track.style.transform = 'none'; if(hint) hint.style.opacity = '0'; return; }
    const zTop    = zoneDocTop();
    const zH      = zone.offsetHeight;
    const vH      = window.innerHeight;
    const entry   = entryPx();
    const scrolled = window.scrollY - (zTop - entry);
    const p = Math.max(0, Math.min(1, scrolled / (zH - vH + entry)));
    const px = p * stepPx() * (SLIDES - 1);
    track.style.transform = `translateX(-${px}px)`;
    const idx = Math.min(SLIDES - 1, Math.floor(p * SLIDES + 0.08));
    dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    if(hint) hint.style.opacity = scrolled > 40 ? '0' : '1';
  }

  function scrollToSlide(idx){
    const zTop = zoneDocTop();
    const zH   = zone.offsetHeight;
    const vH   = window.innerHeight;
    const entry = entryPx();
    const target = (zTop - entry) + (idx / (SLIDES - 1)) * (zH - vH + entry);
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  }

  function currentIdx(){
    const zTop    = zoneDocTop();
    const zH      = zone.offsetHeight;
    const vH      = window.innerHeight;
    const entry   = entryPx();
    const scrolled = window.scrollY - (zTop - entry);
    const p = Math.max(0, Math.min(1, scrolled / (zH - vH + entry)));
    return Math.round(p * (SLIDES - 1));
  }

  const prevBtn = document.getElementById('phPrev');
  const nextBtn = document.getElementById('phNext');
  if(prevBtn) prevBtn.addEventListener('click', () => scrollToSlide(Math.max(0, currentIdx() - 1)));
  if(nextBtn) nextBtn.addEventListener('click', () => scrollToSlide(Math.min(SLIDES - 1, currentIdx() + 1)));

  // Mobile: #product-track is a plain horizontal-scroll/scroll-snap row
  // (not the desktop scroll-scrub above, which is disabled via isMobile()
  // in updateProducts) so prev/next here just scroll it by one card width
  // — reading the width straight off a rendered .pslide plus the row's own
  // gap, rather than reusing CARD_PX/GAP_PX, since those are desktop's
  // fixed 590px card and don't match the mobile card's fluid 92% width.
  const mPrevBtn = document.getElementById('pmPrev');
  const mNextBtn = document.getElementById('pmNext');
  function mobileCardStep(){
    const first = track.querySelector('.pslide');
    if(!first) return track.clientWidth * 0.92;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
    return first.getBoundingClientRect().width + gap;
  }
  function scrollTrackBy(dir){
    if(!isMobile()) return;
    track.scrollBy({ left: dir * mobileCardStep(), behavior: 'smooth' });
  }
  if(mPrevBtn) mPrevBtn.addEventListener('click', function(){ scrollTrackBy(-1); });
  if(mNextBtn) mNextBtn.addEventListener('click', function(){ scrollTrackBy(1); });

  window.addEventListener('scroll', updateProducts, {passive:true});
  window.addEventListener('resize', updateProducts);
  updateProducts();
})();

// ── CENTRE CARD → .is-center (product carousel) ───────────
// Used by the MOBILE card only (see theme.css): the bottle sits tilted and
// straightens once its card is centred in the viewport. Desktop keeps its own
// hover behaviour, so the class is simply unused there.
(function(){
  const track = document.getElementById('product-track');
  if(!track) return;
  const slides = Array.prototype.slice.call(track.querySelectorAll('.pslide'));
  if(!slides.length) return;

  let pending = false;

  function mark(){
    pending = false;
    const mid = window.innerWidth / 2;
    let best = null, bestDist = Infinity, bestW = 0;
    slides.forEach(function(s){
      const r = s.getBoundingClientRect();
      if(!r.width) return;
      const d = Math.abs(r.left + r.width / 2 - mid);
      if(d < bestDist){ bestDist = d; best = s; bestW = r.width; }
    });
    // Only claim "centred" when it is genuinely near the middle, so during a
    // fast swipe no card is straightened mid-flight.
    const centred = best && bestDist < bestW * 0.5 ? best : null;
    slides.forEach(function(s){ s.classList.toggle('is-center', s === centred); });
  }

  function onMove(){
    if(pending) return;
    pending = true;
    requestAnimationFrame(mark);
  }

  window.addEventListener('scroll', onMove, {passive:true});
  window.addEventListener('resize', onMove);
  track.addEventListener('scroll', onMove, {passive:true});
  mark();
})();

// ── AUDIENCE CARDS: DRAG COVERFLOW (mobile only) ───────────
// Ported from a supplied reference implementation. Every .aud-card is
// absolutely positioned with no top/left set — inside a flex container with
// align-items/justify-content:center, an absolutely positioned element's
// fallback ("static") position is computed as if it still participated in
// flex layout, so each card starts centred for free. From there this script
// is the ENTIRE layout engine: it computes each card's circular offset from
// the active index and writes translateX/scale/opacity directly, so several
// cards are visible at once with the active one full-size up front (true
// coverflow) — a different model from the old single-peek scroll-snap
// carousel it replaces. Dragging is native pointer events on the active
// card, not native scroll: there is no scrollable container at all here.
// Guarded to mobile only — on desktop this never touches the cards, so
// theme.css's own hover/rotate rules keep governing there untouched.
(function(){
  const stage = document.getElementById('audStage');
  if(!stage) return;
  const cards = Array.prototype.slice.call(stage.querySelectorAll('.aud-card'));
  if(!cards.length) return;
  const dotsEl = document.getElementById('audDots');

  function isMobile(){ return window.matchMedia('(max-width: 900px)').matches; }

  cards.forEach(function(_, i){
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'aud-dot';
    dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
    dot.addEventListener('click', function(){ goTo(i); });
    if(dotsEl) dotsEl.appendChild(dot);
  });
  const dots = dotsEl ? Array.prototype.slice.call(dotsEl.children) : [];

  let activeIndex = 0;

  // Step distance scales with the card's own rendered width (not a fixed
  // px constant) so neighbour cards peek by a consistent proportion across
  // the range of real phone widths, instead of the reference's fixed 60px
  // (tuned for one ~375px mockup) looking too tight or too wide elsewhere.
  function step(){
    const w = cards[0].getBoundingClientRect().width || 260;
    return w * 0.34;
  }

  function updateCarousel(){
    if(!isMobile()) return;
    const count = cards.length;
    const px = step();
    cards.forEach(function(card, i){
      let offset = i - activeIndex;
      if(offset > count / 2) offset -= count;
      if(offset < -count / 2) offset += count;
      const abs = Math.abs(offset);
      const scale = Math.max(1 - abs * 0.1, 0.75);
      const opacity = abs > 2 ? 0 : 1 - abs * 0.35;
      card.style.transform = 'translateX(' + (offset * px) + 'px) scale(' + scale + ')';
      card.style.opacity = String(opacity);
      card.style.zIndex = String(count - abs);
      card.style.pointerEvents = offset === 0 ? 'auto' : 'none';
    });
    dots.forEach(function(dot, i){ dot.classList.toggle('active', i === activeIndex); });
  }

  function goTo(index){
    const count = cards.length;
    activeIndex = ((index % count) + count) % count;
    updateCarousel();
  }
  function next(){ goTo(activeIndex + 1); }
  function prev(){ goTo(activeIndex - 1); }

  // Arrow buttons flanking the coverflow (see .aud-arrow in theme.css) —
  // just call the same goTo-based next/prev the dots and drag threshold use.
  const arrowPrev = document.getElementById('audPrev');
  const arrowNext = document.getElementById('audNext');
  if(arrowPrev) arrowPrev.addEventListener('click', prev);
  if(arrowNext) arrowNext.addEventListener('click', next);

  let dragging = false, startX = 0, deltaX = 0, activeCard = null;

  function onPointerDown(e){
    if(!isMobile()) return;
    dragging = true; startX = e.clientX; deltaX = 0;
    activeCard = cards[activeIndex];
    activeCard.classList.add('dragging');
    activeCard.setPointerCapture(e.pointerId);
  }
  function onPointerMove(e){
    if(!dragging) return;
    deltaX = e.clientX - startX;
    activeCard.style.transform = 'translateX(' + deltaX + 'px) scale(1)';
  }
  function onPointerUp(){
    if(!dragging) return;
    dragging = false;
    activeCard.classList.remove('dragging');
    const threshold = step() * 0.5;
    if(deltaX > threshold) prev();
    else if(deltaX < -threshold) next();
    else updateCarousel();
    activeCard = null;
  }

  stage.addEventListener('pointerdown', function(e){
    if(e.target.closest('.aud-card') === cards[activeIndex]) onPointerDown(e);
  });
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  function onResize(){
    if(isMobile()){
      updateCarousel();
    } else {
      // Hand control back to theme.css's static desktop rules.
      cards.forEach(function(card){
        card.style.transform = '';
        card.style.opacity = '';
        card.style.zIndex = '';
        card.style.pointerEvents = '';
      });
    }
  }
  window.addEventListener('resize', onResize);
  onResize();
})();

// ── STATS STRIP: CONTINUOUS AUTO-SCROLL (mobile carousel) ────
// Drives #stats-track with a CSS transform, NOT native scrollLeft. Setting
// .scrollLeft on a `-webkit-overflow-scrolling:touch` container is unreliable
// on iOS Safari — the async momentum-scroll layer frequently ignores or
// fights small programmatic writes, which is why an earlier scrollLeft-based
// version didn't visibly move on real phones. transform: translateX() has no
// such quirk and is GPU-composited.
// The track holds the 3 stats twice back-to-back (see stats-strip.liquid).
// Once it has scrolled exactly one set's width, the on-screen content is
// pixel-identical to the start, so resetting the offset to 0 is invisible —
// that's what makes the loop seamless instead of jump-cutting.
(function(){
  const strip = document.getElementById('stats-strip');
  const track = document.getElementById('stats-track');
  if(!strip || !track) return;

  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }

  const SPEED = 0.6; // px per animation frame
  let rafId = null;
  let paused = false;
  let resumeTimer = null;
  let pos = 0;
  let setWidth = 0;

  function measure(){
    // The track renders the 3 stats twice, back-to-back. The true loop
    // distance is the gap between the FIRST original item and the FIRST
    // duplicate item — NOT scrollWidth/2, which can be off by a few pixels
    // once flex `gap` is unevenly distributed across the two halves and
    // causes a visible "hitch" right at the loop point.
    const items = track.querySelectorAll('.sstat');
    const firstDup = track.querySelector('.sstat--dup');
    if(items.length && firstDup){
      setWidth = firstDup.offsetLeft - items[0].offsetLeft;
    } else {
      setWidth = track.scrollWidth / 2;
    }
  }

  function tick(){
    if(!isMobile()){ track.style.transform = ''; rafId = null; return; }
    if(!paused && setWidth > 1){
      pos += SPEED;
      if(pos >= setWidth){ pos -= setWidth; }
      track.style.transform = 'translateX(-' + pos + 'px)';
    }
    rafId = requestAnimationFrame(tick);
  }

  function pause(){
    paused = true;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function(){ paused = false; }, 2500);
  }

  strip.addEventListener('touchstart', pause, { passive: true });
  strip.addEventListener('pointerdown', pause);
  strip.addEventListener('wheel', pause, { passive: true });

  window.addEventListener('resize', function(){
    measure();
    if(isMobile() && rafId === null){ rafId = requestAnimationFrame(tick); }
    if(!isMobile() && rafId !== null){ cancelAnimationFrame(rafId); rafId = null; track.style.transform = ''; }
  });

  measure();
  if(isMobile()){ rafId = requestAnimationFrame(tick); }
})();

// ── COMPARISON BARS — fill when scrolled into view ───
(function(){
  const compare = document.getElementById('why-cards');
  if(!compare) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ compare.classList.add('in'); io.disconnect(); }
    });
  }, { threshold: 0.2 });
  io.observe(compare);
})();

// ── ADD TO CART ──────────────────────
function addToCart(variantId, btn){
  const original = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
  .then(function(res){
    if(!res.ok){
      // Shopify returns an error (e.g. sold out / not available)
      btn.textContent = (res.data && res.data.description) ? 'Sold out' : 'Unavailable';
      setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 1800);
      return;
    }
    btn.textContent = 'Added ✓';
    // Toast + cart drawer sync (no navigation)
    var slide = btn.closest('.pslide');
    var pname = slide ? (slide.querySelector('.pcard-name') || {}).textContent : '';
    if (window.nbToast) { window.nbToast(pname || ''); }
    if (window.nbCartRefresh) { window.nbCartRefresh(); }
    setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 1600);
  })
  .catch(function(){
    btn.textContent = 'Error';
    setTimeout(function(){ btn.textContent = original; btn.disabled = false; }, 1800);
  });
}
